export default __webpack_public_path__ + "static/media/Selection_088.f614ff53.png";